import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import {
  PinkPrimaryButton,
  PinkSmallPrimaryButton,
  TertiaryButton,
  LinkButton,
  buttonTypes,
  BluePrimaryButton,
  BlueSmallPrimaryButton,
  PinkTertiaryButton,
} from './Button/BaseButton';
import TransitionButton, { buttonStatuses } from './Button/TransitionButton';

export const ButtonVariations = {
  pinkPrimary: 'pinkPrimary',
  bluePrimary: 'bluePrimary',
  pinkPrimarySmall: 'pinkPrimarySmall',
  bluePrimarySmall: 'bluePrimarySmall',
  tertiary: 'tertiary',
  pinkTertiary: 'pinkTertiary',
  link: 'link',
};

const Fixed = styled.div`
  position: relative;
  ${props => css`
    width: ${props.width || '100%'};
  `};
`;

const Button = props => {
  const { variation, animationEnabled, ...other } = props;

  // I'm not sure the proper order, but text prop takes precedent over children here
  // can change if you want
  const text = props.text || props.children;
  /*
   For the animation/transition type button, you need to either provide a width,
   or give it a container to sit in in which case it will set itself to width 100%
  */
  return (
    <Fragment>
      {variation === ButtonVariations.pinkPrimary && animationEnabled && (
        <Fixed width={other.width}>
          <TransitionButton {...other}>{text}</TransitionButton>
        </Fixed>
      )}
      {variation === ButtonVariations.pinkPrimary && !animationEnabled && (
        <PinkPrimaryButton variant="contained" {...other}>
          {text}
        </PinkPrimaryButton>
      )}
      {variation === ButtonVariations.bluePrimary && !animationEnabled && (
        <BluePrimaryButton variant="contained" {...other}>
          {text}
        </BluePrimaryButton>
      )}
      {variation === ButtonVariations.pinkPrimarySmall && (
        <PinkSmallPrimaryButton variant="contained" {...other}>
          {text}
        </PinkSmallPrimaryButton>
      )}
      {variation === ButtonVariations.bluePrimarySmall && (
        <BlueSmallPrimaryButton variant="contained" {...other}>
          {text}
        </BlueSmallPrimaryButton>
      )}
      {variation === ButtonVariations.tertiary && (
        <TertiaryButton variant="outlined" {...other}>
          {text}
        </TertiaryButton>
      )}
      {variation === ButtonVariations.pinkTertiary && (
        <PinkTertiaryButton variant="outlined" {...other}>
          {text}
        </PinkTertiaryButton>
      )}
      {variation === ButtonVariations.link && <LinkButton {...other}>{text}</LinkButton>}
    </Fragment>
  );
};

Button.propTypes = {
  text: PropTypes.string,
  variation: PropTypes.oneOf(buttonTypes),
  status: PropTypes.oneOf(buttonStatuses),
  width: PropTypes.string,
  children: PropTypes.any,
  animationEnabled: PropTypes.bool,
  className: PropTypes.string, //www.styled-components.com/docs/basics#styling-any-components
};

Button.defaultProps = {
  variation: 'pinkPrimary',
  animationEnabled: false,
};

export default Button;
